export const visitSchedule =
{
  path: '/visit-schedule',
  name: 'visitSchedule',
  hidden: false,
  component: () => import('@/components/visitSchedule/index'),
  meta: {
    title: 'Jadwal Kunjungan',
    icon: 'fa-calendar',
    roles: ['dokter']
  },
}
export default visitSchedule



// WEBPACK FOOTER //
// ./src/router/modules/visit-schedule.js